import React from "react";

import { CreditCardIcon } from "components";
import { CreditCardTypes, PaymentMethodValues } from "types";

import styles from "./paymentMethodsDdl.module.scss";

type CreditCardLabelProps = {
	data: PaymentMethodValues;
};

const CreditCardLabel = ({ data }: CreditCardLabelProps) => {
	const creditCardTypeName = CreditCardTypes.getByValue(
		data?.cardType,
	)?.displayName;

	return (
		<>
			<div className={styles.label}>
				<div className={styles.title}>
					{`${creditCardTypeName} ${data?.cardNumber}`}
				</div>
				<div className={styles.notes}>
					{`Expiration Date: ${data?.expirationDate}`}
				</div>
			</div>
			<div className={styles.iconHolder}>
				<CreditCardIcon
					name={CreditCardTypes.getByValue(data?.cardType)?.name}
				/>
			</div>
		</>
	);
};

export default CreditCardLabel;
